import { useEffect } from "react";
import { useNavigate } from "react-router";
import axios from "axios";

function Wa1500Downloader(props)
{
    const navigate = useNavigate();

     useEffect(() => {

        
    var userNtk = window.localStorage.getItem("userNtk");
     const a = document.createElement("a");
        a.href = `https://nodeppcbackend-production.up.railway.app/api/reports/wa1500?Stage=${encodeURIComponent(props.stage)}&Token=${encodeURIComponent(userNtk)}`;
        a.download = `WA1500_${props.stage}.zip`;

        document.body.appendChild(a);
        a.click();
        a.remove();

        navigate("/admin/dashboard");

        }, [navigate])
       
     return(
        <div className="container" style={{width:'500px', marginTop: "20vh", marginLeft: "-10vw"}}>
           
        </div>

    );
}

export default Wa1500Downloader;
